import { gql } from '@/utilities/gql';
import type { VariablesOf } from '@/utilities/gql';
import type { QueryFunctionContext } from '@tanstack/react-query';

import { gqlClient } from '@/utilities/graphQLClient';

import {
  WATCHLIST_FRAGMENT,
  WATCHLIST_ITEM_FRAGMENT,
  WATCHLIST_NARRATIVE_FAIR_VALUE_FRAGMENT,
} from './watchlist-fragment';

const QUERY = gql(
  `
  query getWatchlist($id: String) {
    Watchlist(id: $id) {
      ...watchlistFields
      # June Hackathon 2025
      publicToken
      items {
        ...watchlistItemFields
        ...narrativeFairValueFields
      }
    }
  }
`,
  [
    WATCHLIST_FRAGMENT,
    WATCHLIST_ITEM_FRAGMENT,
    WATCHLIST_NARRATIVE_FAIR_VALUE_FRAGMENT,
  ]
);

type WatchlistId = VariablesOf<typeof QUERY>['id'];

export const queryFn = async ({
  queryKey: [, id],
}: QueryFunctionContext<[string, WatchlistId]>) => {
  if (typeof id === 'undefined') {
    throw new Error(`Cannot fetch Watchlist for id ${id}`);
  }

  const response = await gqlClient.request(QUERY, { id });

  if ('Watchlist' in response) {
    return response.Watchlist;
  }
};
